import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { toast } from 'material-react-toastify';
import { isTokenValid } from '../../utils/Auth';
import { bodyWidth } from '../../utils/Style';
import { forgotPassword } from '../../api/Auth';
import { useThemeColor } from '../../hooks/useThemeColor';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';

export const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  const { primary, secondary } = useThemeColor();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isTokenValid()) {
      navigate('/account');
    }
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    forgotPassword(email)
      .then(() => {
        toast.success('Şifre sıfırlama linki E-Posta adresinize gönderildi.');
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title='Şifremi Unuttum' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          py: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            px: 2.5,
            py: 2,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: '100%',
          }}
        >
          <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
            Şifre Sıfırlama
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              width: '100%',
            }}
          >
            <Typography>E-Posta</Typography>

            <TextField
              size='small'
              fullWidth
              disabled={loading}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ maxWidth: 400 }}
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Button
              variant='contained'
              onClick={handleSubmit}
              disabled={loading}
              sx={{
                textTransform: 'none',
                backgroundColor: primary,
                color: secondary,
              }}
            >
              Onayla
            </Button>

            {loading && <CircularProgress color='primary' />}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
